<div id="scrn">
  <div id="scrn-c">
    <div class="message-heading">
      {{locale.titleText}}
    </div>
    <div class="message-text">
      {{locale.subtitleText}}
    </div>
    <button class="form-control btn margin-top" (click)="seeMyResults()">
        {{locale.resultsButtonText}}
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/questionnaire/review-questions/review-questions.component.html